<template>
  <div>
    <div class="row">
      <!--<span>
         <font-awesome-icon
          title="Back" 
          :icon="['fas', 'step-backward']" 
          @click="backForwardFrame(-1)" 
          style="font-size:16px;cursor:pointer;"
        ></font-awesome-icon> -->
      <div @click="playStop()" title="Play / Stop" class="col-md-2">
        <font-awesome-icon
          :icon="['fas', 'play']"
          class="mapButtons"
        ></font-awesome-icon>
        <span class="mapButtons">/</span>
        <font-awesome-icon
          :icon="['fas', 'stop']"
          class="mapButtons"
        ></font-awesome-icon>
      </div>
      <div id="timestamp" class="col-md-8">
        {{ timestampValue }}
      </div>
      <!-- <div id="timestamp"  class="col-md-8">FRAME TIME</div> -->
      <!-- <font-awesome-icon 
          title="Forward" 
          :icon="['fas', 'step-forward']" 
          @click="backForwardFrame(1)" 
          class="mapButtons">
        </font-awesome-icon>
      </span> -->
    </div>

    <!--   <ul style="height: 20px;">
       <li><input type="button" @click="" onclick="stop(); showFrame(animationPosition - 1); return;" value="" /></li> 
        <li class="fas fa-play" @click="playStop"><input type="button"    value="Play / Stop" /></li>
         <li><input type="button" onclick="stop(); showFrame(animationPosition + 1); return;" value="&gt;" /></li> 
    </ul>-->

    <!-- <div id="timestamp" style="text-align:center;  height: 20px;">FRAME TIME</div> -->
    <!-- <i class="fas fa-play"></i>
<font-awesome-icon
                
                :style="{
                  'font-size': '24px'
                 
                }"
                :icon="['fad', 'fa-adjust']"
                
              /> -->
    <!-- <div id="mapid" style="position: absolute; top: 80px; left: 0; bottom: 0; right: 0;"></div> -->
    <div id="mapid" style="width: 100%; height: 400px"></div>
  </div>
</template>

<script>
export default {
  name: "MapRadar",
  data() {
    return {
      map: null,
      timestamps: [],
      radarLayers: [],
      radarHost: "https://tilecache.rainviewer.com",
      animationPosition: 0,
      animationTimer: false,
      timestampValue: "",
    };
  },
  mounted() {
    if (this.initMap) {
      this.checkAndAttachMapScript().then(() => {
        this.initMap();
      });
    }
  },
  beforeDestroy() {
    this.stop();
  },
  props: {
    mapData: Object,
  },
  methods: {
    getCurrentLocationTimezone() {
      let th = this;
      var targetDate = new Date(); // Current date/time timestamp of user computer
      var timestamp =
        targetDate.getTime() / 1000 + targetDate.getTimezoneOffset() * 60;
      fetch(
        `https://maps.googleapis.com/maps/api/timezone/json?location=${this.mapData.Latitude},${this.mapData.Longitude}&timestamp=${timestamp}&key=AIzaSyB0bu5ynfRL9VNIwuAgbewUhKz3_yllmrs`
      )
        .then((res) => res.json())
        .then((response) => {
          //Timezone abbriviated
          let timeZoneSplit = response.timeZoneName?.split(" ");
          let timeZoneString = "(";

          if (timeZoneSplit) {
            for (var j = 0; j < timeZoneSplit?.length; j++) {
              timeZoneString = timeZoneString + timeZoneSplit[j].charAt(0);
            }
            timeZoneString = timeZoneString + ")";

            //getting date and time of lat long
            var offsets = response.dstOffset * 1000 + response.rawOffset * 1000;
            var localdate = new Date(timestamp * 1000 + offsets);

            //remove existing timezone and format date
            if (localdate != null && localdate != undefined) {
              let splitDate = localdate.toString().split(" GMT")[0];
              let options = {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              };
              let formattedDate = new Date(splitDate).toLocaleDateString(
                "en-US",
                options
              );
              th.timestampValue = formattedDate + " " + timeZoneString;
            }
          } else th.timestampValue = "";
        })
        .catch((status) => {
          console.log("Request failed.  Returned status of", status);
        });
    },
    checkAndAttachMapScript() {
      if (window.google && window.google.maps) {
        return Promise.resolve(true);
      }

      if (window.__googleMapsApiPromise) {
        return window.__googleMapsApiPromise;
      }

      window.__googleMapsApiPromise = new Promise((resolve, reject) => {
        window.__initGoogleMapsApi = () => resolve(true);

        const existingScript = document.getElementById("google-maps-js");
        if (existingScript) {
          existingScript.addEventListener("load", () => resolve(true), {
            once: true,
          });
          existingScript.addEventListener("error", reject, { once: true });
          return;
        }

        const script = document.createElement("script");
        script.id = "google-maps-js";
        script.async = true;
        script.defer = true;
        script.src =
          "https://maps.googleapis.com/maps/api/js?key=AIzaSyBTrD1gqJ9fesXs8Hsxk2a9Y9oLkHpHCbA&loading=async&callback=__initGoogleMapsApi";
        script.onerror = (err) => {
          window.__googleMapsApiPromise = null;
          reject(err);
        };
        document.body.appendChild(script);
      });

      return window.__googleMapsApiPromise;
    },
    markerInfo: function (index = null) {
      this.hoveredMarker = index;
    },
    initMap() {
      var ref = this;
      let mapDiv = document.getElementById("mapid");
      if (!mapDiv) {
        return false;
      }
      this.map = new google.maps.Map(mapDiv, {
        center: { lat: +this.mapData.Latitude, lng: +this.mapData.Longitude },
        zoom: 7,
      });
      this.map.addListener("zoom_changed", () => {
        const currentZoom = this.map.getZoom() || 0;
        const opacity = currentZoom > 7 ? 0 : 0.6;
        this.radarLayers.forEach((layer) => {
          if (layer && typeof layer.setOpacity === "function") {
            layer.setOpacity(opacity);
          }
        });
      });
      // this.map = new google.maps.Map(mapDiv, {
      //   center: { lat: +this.mapData.Latitude, lng: +this.mapData.Longitude },
      //   zoom:
      //     this.mapData.Dim_MarketTypeID == 15
      //       ? 10
      //       : this.mapData.MarketReferenceID == 4 ||
      //         this.mapData.MarketReferenceID == 14 ||
      //         this.mapData.MarketReferenceID == 14 ||
      //         (this.mapData.MarketReferenceID == 13) |
      //           (this.mapData.MarketReferenceID == 44) ||
      //         this.mapData.MarketReferenceID == 47 ||
      //         this.mapData.MarketReferenceID == 1 ||
      //         this.mapData.MarketReferenceID == 3
      //       ? 4
      //       : 6.5,
      // });

      /**
       * Load actual radar animation frames timestamps from RainViewer API
       */
      var apiRequest = new XMLHttpRequest();
      apiRequest.open(
        "GET",
        "https://api.rainviewer.com/public/weather-maps.json",
        true
      );
      apiRequest.onload = function () {
        let payload;
        try {
          payload = JSON.parse(apiRequest.response);
        } catch (err) {
          ref.timestamps = [];
          return;
        }

        const frames = payload?.radar?.past || [];
        ref.radarHost = payload?.host || ref.radarHost;

        // Keep existing animation logic, but store frame paths instead of unix timestamps.
        ref.timestamps = frames.map((f) => f.path).filter(Boolean);

        if (!ref.timestamps.length) {
          return;
        }

        ref.showFrame(ref.timestamps.length - 1);
      };
      apiRequest.onerror = function () {
        ref.timestamps = [];
      };
      apiRequest.send();
    },
    backForwardFrame(operation) {
      this.stop();
      this.showFrame(this.animationPosition + operation);
      return;
    },
    addLayer(ts) {
      var ref = this;
      const framePath = ts || "";

      if (!framePath) {
        return;
      }

      if (!ref.radarLayers[framePath]) {
        ref.radarLayers[framePath] = new google.maps.ImageMapType({
          getTileUrl: function (coord, zoom) {
            // RainViewer supports up to zoom 7 only.
            if (zoom > 7) {
              // 1x1 transparent GIF, avoids external request and hides overlay.
              return "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
            }

            return [
              ref.radarHost,
              framePath,
              "/256/",
              zoom,
              "/",
              coord.x,
              "/",
              coord.y,
              "/2/1_1.png",
            ].join("");
          },
          tileSize: new google.maps.Size(256, 256),
          opacity: 0.6,
        });
        this.map.overlayMapTypes.push(ref.radarLayers[framePath]);
      }
    },
    changeRadarPosition(position, preloadOnly) {
      if (!Array.isArray(this.timestamps) || this.timestamps.length === 0) {
        return;
      }

      while (position >= this.timestamps.length) {
        position -= this.timestamps.length;
      }
      while (position < 0) {
        position += this.timestamps.length;
      }

      var currentTimestamp = this.timestamps[this.animationPosition];
      var nextTimestamp = this.timestamps[position];
      this.addLayer(nextTimestamp);

      if (preloadOnly) {
        return;
      }

      this.animationPosition = position;

      if (this.radarLayers[currentTimestamp]) {
        this.radarLayers[currentTimestamp].setOpacity(0);
      }
      this.radarLayers[nextTimestamp].setOpacity(0.6);
      this.getCurrentLocationTimezone();
      //document.getElementById("timestamp").innerHTML = (new Date(nextTimestamp * 1000)).toString();
    },
    showFrame(nextPosition) {
      var preloadingDirection =
        nextPosition - this.animationPosition > 0 ? 1 : -1;

      this.changeRadarPosition(nextPosition);

      // preload next next frame (typically, +1 frame)
      // if don't do that, the animation will be blinking at the first loop
      this.changeRadarPosition(nextPosition + preloadingDirection, true);
    },
    stop() {
      if (this.animationTimer) {
        clearTimeout(this.animationTimer);
        this.animationTimer = false;
        return true;
      }
      return false;
    },
    play() {
      this.showFrame(this.animationPosition + 1);

      // Main animation driver. Run this function every 500 ms
      this.animationTimer = setTimeout(() => this.play(), 500);
    },
    playStop() {
      // console.log("playstop clicked");
      if (!this.stop()) {
        this.play();
      }
    },
  },
};
</script>

<style>
li {
  list-style: none;
  display: inline-block;
}
.mapButtons {
  font-size: 14px;
  margin-left: 5px;
  cursor: pointer;
  color: black;
}
#timestamp {
  text-align: center;
  height: 20px;
  padding-bottom: 35px;
}
</style>